<template>
  <v-alert
    :value="unsupported"
    type="warning"
    prominent
    text
    dismissible
    transition="scale-transition"
    style="width: 100%"
  >
    {{ $t('alerts.unsupported_browser') }}
  </v-alert>
</template>

<script>
import { detect } from 'detect-browser'

export default {
  name: 'AlertUnsupportedBrowser',

  computed: {
    unsupported() {
      const browser = detect()
      return browser && browser.name === 'ie'
    }
  }
}
</script>
